/**
 * @fileoverview gta renderer.
 * @author gtaer
 * @ref zelos
 */
"use strict";

import Blockly from "blockly";
import "./info";
import "./constants";
import "./drawer";
import "./field.js";
import "./gta_define_function.js";
// import "./basenode.js";

// goog.provide("Blockly.gta.Renderer");

// goog.require("Blockly.blockRendering");
// goog.require("Blockly.blockRendering.Renderer");
// goog.require("Blockly.utils.object");
// goog.require("Blockly.gta.ConstantProvider");
// goog.require("Blockly.gta.Drawer");
// goog.require("Blockly.gta.RenderInfo");

/**
 * The gta renderer.
 * @package
 * @constructor
 * @extends {Blockly.blockRendering.Renderer}
 */
Blockly.gta.Renderer = function() {
  Blockly.gta.Renderer.superClass_.constructor.call(this);
};
Blockly.utils.object.inherits(
  Blockly.gta.Renderer,
  Blockly.blockRendering.Renderer
);

/**
 * Create a new instance of the renderer's constant provider.
 * @return {!Blockly.gta.ConstantProvider} The constant provider.
 * @protected
 * @override
 */

Blockly.gta.Renderer.prototype.makeConstants_ = function() {
  return new Blockly.gta.ConstantProvider();
};

/**
 * Create a new instance of the renderer's render info object.
 * @param {!Blockly.BlockSvg} block The block to measure.
 * @return {!Blockly.gta.RenderInfo} The render info object.
 * @protected
 * @override
 */
Blockly.gta.Renderer.prototype.makeRenderInfo_ = function(block) {
  return new Blockly.gta.RenderInfo(this, block);
};

/**
 * Create a new instance of the renderer's drawer.
 * @param {!Blockly.BlockSvg} block The block to render.
 * @param {!Blockly.blockRendering.RenderInfo} info An object containing all
 *   information needed to render this block.
 * @return {!Blockly.gta.Drawer} The drawer.
 * @protected
 * @override
 */
Blockly.gta.Renderer.prototype.makeDrawer_ = function(block, info) {
  return new Blockly.gta.Drawer(
    block,
    /** @type {!Blockly.gta.RenderInfo} */
    (info)
  );
};

// 直接注册
Blockly.blockRendering.register("gta", Blockly.gta.Renderer);

// Blockly.gta.Renderer.register = function() {
//   var rendererName = "gta";
//   Blockly.blockRendering.register(rendererName, Blockly.gta.Renderer);
//   return rendererName;
// };
